import { flow } from '@helo/utils'

import type { QueryOutput } from '../../Query'
import { RenderPipeline } from '../../RenderPipeline'
import {
  type ChartReferenceLineItem,
  type ChartReferenceLineOptions,
  chartReferenceLineOptions,
} from './ChartReferenceLine.options'
import {
  ChartReferenceLineInputParts,
  ChartReferenceLineOutputParts,
} from './ChartReferenceLine.parts'

export { chartReferenceLineOptions } from './ChartReferenceLine.options'
export type {
  ChartReferenceLineItem,
  ChartReferenceLineOptions,
} from './ChartReferenceLine.options'

export type ChartReferenceLineInput = ChartReferenceLineOptions

export type ChartReferenceLineOutput = {
  referenceLines: ChartReferenceLineItem[]
}

export type ChartReferenceLinePriorOutput = Pick<QueryOutput, 'contentNode'>

const chartReferenceLineSetup = () =>
  RenderPipeline.createFeatureSetup<
    ChartReferenceLineInput,
    ChartReferenceLineOutput,
    ChartReferenceLinePriorOutput
  >(
    flow(
      ChartReferenceLineInputParts.setupInput(),
      ChartReferenceLineInputParts.setup_referenceLinesInput(),
      ChartReferenceLineOutputParts.setReferenceLines(),
    ),
  )

export const ChartReferenceLine = {
  options: chartReferenceLineOptions,
  setup: chartReferenceLineSetup,
}
